import React from 'react';
import { Alert } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { TenantSamlConfigPanel, useCapability } from '@digiwedge/access-control-pages';

import { useIdp } from '../auth/IdpProvider.js';

export default function TenantSamlConfigPage(): React.ReactElement {
  const { tenantId } = useParams<{ tenantId: string }>();
  const navigate = useNavigate();
  const idp = useIdp();
  const capabilityScope = tenantId ? { tenantId } : {};
  const canRead = useCapability({ feature: 'TENANT_MGMT', action: 'read', ...capabilityScope });
  const canUpdate = useCapability({ feature: 'TENANT_MGMT', action: 'update', ...capabilityScope });
  const canDelete = useCapability({ feature: 'TENANT_MGMT', action: 'delete', ...capabilityScope });

  if (!tenantId) {
    return (
      <Alert
        type="error"
        message="Tenant not found"
        description="Missing tenant ID in route."
        showIcon
      />
    );
  }

  return (
    <TenantSamlConfigPanel
      api={idp}
      tenantId={tenantId}
      canRead={canRead}
      canUpdate={canUpdate}
      canDelete={canDelete}
      onBackToTenants={() => navigate('/tenants')}
    />
  );
}
